<div class="container" *ngIf="dynamicHTML; else loading">
  <div [innerHTML]="dynamicHTML"></div>
</div>
<ng-template #loading>
  <p>Loading content...</p>
</ng-template>
